module.exports = __webpack_public_path__ + "img/anaerobic-bioreactor.3a19f53b.jpg";